<template>
	<div class="banner d-flex flex-align-items-center">
		<div class="content">
			<!-- <p><center><img alt="logo" class="static-logo" src="../assets/img/svg/24px/logo_24px.svg" /></center></p> -->
			<p><center><img alt="logo" class="static-logo" src="../assets/img/svg/xxx/logo_blue_light.svg" /></center></p>
			<p class="pt-4">
				<span class="text-bold">Dyelec Lesotho</span> is a Lesotho based Electrical/Electronic Engineering and Building 
					Services consulting limited liability firm. Established in 1994, the firm has over the years 
					developed capacity to offer a wide range of professional services in building services, 
					electrical and electronic engineering from feasibility studies to final completion.
			</p>
		</div>
		<!-- <div class="logo"><img alt="logo" src="../assets/img/svg/24px/logo_white_24px.svg" /></div> -->
		<div ref="teaser" class="teaser background-cover">
			<div :class="{'animate-div': run_animations}"><span>Lighting</span></div>
			<div :class="{'animate-div': run_animations}"><span>Electrification</span></div>
			<div :class="{'animate-div': run_animations}"><span>Sub-Stations</span></div>
			<div :class="{'animate-div': run_animations}"><span>Installations</span></div>
			<div :class="{'animate-div': run_animations}"><span>Security Systems</span></div>
			<div :class="{'animate-div': run_animations}"><span>Telephone Services</span></div>
			<div :class="{'animate-div': run_animations}"><span>Electronic System and Security Systems</span></div>
			<div :class="{'animate-div': run_animations}"><span>Reticulation</span></div>
			<div :class="{'animate-div': run_animations}"><span>Networks</span></div>
			<div :class="{'animate-div': run_animations}"><span>Air Conditioning</span></div>
		</div>
	</div>
</template>

<script>
	import emitter from '@/emitter';
	export default {
		name: 'Banner',
		data() {
			return {
				run_animations: true
			};
		},
		created() {
			emitter.$on('stop-banner-animations', this.stopBannerAnimations);
		},
		beforeDestroy() {
			emitter.$off('stop-banner-animations', this.stopBannerAnimations);
		},
		mounted() {
			document.querySelector('.banner').style.height = document.querySelector('.banner > .content').clientHeight * 1.5 + 'px';
		},
		methods: {
			stopBannerAnimations() {
				this.run_animations = false;
				emitter.$off('stop-banner-animations', this.stopBannerAnimations);
			}
		}
	};
</script>

<style scoped lang="scss">
	@import '../assets/style/main.scss';


	@mixin make-gray($opc, $timing) {
		&::before {
			position: absolute;
			content: '';
			height: 100%;
			width: 100%;
			background-color: rgba(6, 36, 61, $opc);
			mix-blend-mode: color;

			@media (hover: hover) and (pointer: fine){
				animation: swi $timing alternate infinite ease-in-out;
				@keyframes swi {
					0% {
						background-color: rgba(6, 36, 61, 0.2);
					}
					25% {
						background-color: rgba(6, 36, 61, $opc);
					}
					50% {
						background-color: rgba(6, 36, 61, .9);
					}
					75% {
						background-color: rgba(6, 36, 61, .1);
					}
					100% {
						background-color: rgba(6, 36, 61, $opc);
					}
				}
			}
		}
	}

	@mixin teaser {
		transform-style: inherit;
		align-self: stretch;
		flex-grow: 1;
		display: grid;
		grid-template-columns: repeat(12, 1fr);
		grid-auto-rows: 1fr;
		grid-auto-flow: dense;
		white-space: nowrap;

				
		div {
			position: relative;
			span {
				position: absolute;
				color: $white-light-tr-2;
				mix-blend-mode: luminosity;
				opacity: 0.5;
			}
			@media (hover: hover) and (pointer: fine){ 
				box-shadow: 1px 0px 16px 1px rgba(0, 0, 0, 0.2);
			}
			font-weight: 700;

			align-self: stretch;
			display: flex;
			justify-content: center;
			align-items: center;


			
			

			&:nth-of-type(1) {
				font-size: 1vw;
				letter-spacing: 1ch;
				grid-column: span 3;
				grid-row: span 3;
				@include make-gray(1, 33s);				
			}
			&:nth-of-type(2) {
				font-size: 1vw;
				letter-spacing: 3ch;
				grid-column: span 7;
				grid-row: span 2;
				@include make-gray(1, 14s);
			}
			&:nth-of-type(3) {
				font-size: 1vw;
				letter-spacing: 1ch;
				grid-column: span 5;
				grid-row: span 5;
				@include make-gray(0.7, 6s);
			}
			&:nth-of-type(4) {
				font-size: 1vh;
				letter-spacing: 1ch;
				span {
					transform: rotate(90deg);
				}
				grid-column: span 2;
				grid-row: span 3;
				@include make-gray(0.7, 14.5s);
			}
			&:nth-of-type(5) {
				font-size: 1vh;
				letter-spacing: 1ch;
				span {
					transform: rotate(90deg);
				}
				grid-column: span 3;
				grid-row: span 6;
				@include make-gray(0.5, 14s);
			}
			&:nth-of-type(6) {
				font-size: 1vmin;
				letter-spacing: 1ch;
				span {
					transform: rotate(-45deg);
				}
				grid-column: span 5;
				grid-row: span 5;
				@include make-gray(1, 16s);
			}
			&:nth-of-type(7) {
				font-size: 1.6vh;
				letter-spacing: 1ch;
				span {
					transform: rotate(90deg);
				}
				grid-column: span 2;
				grid-row: span 11;
				@include make-gray(1, 8.5s);
			}
			&:nth-of-type(8) {
				font-size: 1vw;
				letter-spacing: 1ch;
				grid-column: 1 / 5;
				grid-row: 10 / 12;
				@include make-gray(1, 17s);
			}
			&:nth-of-type(9) {
				font-size: 1vmin;
				letter-spacing: 1ch;
				span {
					transform: rotate(55deg);
				}
				grid-column: span 2;
				grid-row: span 3;
				@include make-gray(0.1, 15s);
			}
			&:nth-of-type(10) {
				font-size: 1vh;
				letter-spacing: 1ch;
				span {
					transform: rotate(90deg);
				}
				grid-column: span 2;
				grid-row: span 4;
				@include make-gray(1, 14s);
			}

			// The animation running on the banner will be stopped when nav bar hits the top
			&::before {
				animation-play-state: paused !important;
			}
			&.animate-div {
				&::before {
					animation-play-state: running !important;
				}
			}
		}
	}



	/*	************************************************************************************
		************************************************************************************
		************************************************************************************
		************************************************************************************
		************************************************************************************
		************************************************************************************
		************************************************************************************
		************************************************************************************
		************************************************************************************ */


	.banner {
		min-height: 100%;
		transform-style: preserve-3d;

		transform: translate3d(0px, 0px, -50px) scale(1.5);

		@media (max-width: 768px) {
			transform: translate3d(0px, 0px, -25px) scale(1.25);
		}

		@mixin disable-parallax {
			@supports not (scroll-behavior: smooth) {
				transform-style: none !important;
				.content {
					transform-style: none !important;
					z-index: 1;
					transform: unset;
					max-width: 90vw;
					margin-left: 5vw;
					.static-logo {
						height: 72px;
					}
				}
				transform: translate3d(0px, 0px, 0px) scale(1);
			}
		}
		//iPad in landscape
		@media only screen  and (min-device-width : 768px) 
							and (max-device-width : 1024px) 
							and (orientation : landscape) { 
			@include disable-parallax();
		}
		//iPad in portrait
		@media only screen  and (min-device-width : 768px) 
							and (max-device-width : 1024px) 
							and (orientation : portrait) { 
			@include disable-parallax();
		}

		//iPhone 6, 7, & 8 in landscape
		@media only screen  and (min-device-width : 375px) 
							and (max-device-width : 667px) 
							and (orientation : landscape) { 
			@include disable-parallax();
		} 
		
		//iPhone 6, 7, & 8 in portrait
		@media only screen  and (min-device-width : 375px) 
							and (max-device-width : 667px) 
							and (orientation : portrait) { 
			@include disable-parallax();
		} 

		//iPhone 6, 7, & 8 Plus in landscape

		@media only screen 	and (min-device-width : 414px) 
							and (max-device-width : 736px) 
							and (orientation : landscape) { 
			@include disable-parallax();
		}

		//iPhone 6, 7, & 8 Plus in portrait
		@media only screen 	and (min-device-width : 414px) 
							and (max-device-width : 736px) 
							and (orientation : portrait) { 
			@include disable-parallax();
		} 

		//iPhone 5 & 5S in landscape

		@media only screen  and (min-device-width : 320px) 
							and (max-device-width : 568px) 
							and (orientation : landscape) { 
			@include disable-parallax();
		}

		//iPhone 5 & 5S in portrait

		@media only screen  and (min-device-width : 320px) 
							and (max-device-width : 568px) 
							and (orientation : portrait) { 
			@include disable-parallax();
		} 

		>.teaser {
			@include teaser();
		}
	}
	.static-logo {
		width: 50%;
	}
	.text-bold {
		font-size: 1.3em;
	}
	.content {
		font-size: 16px;
		transform-style: inherit;
		transform-origin: center center;
		transform: translate3d(0px, 0px, 50px) scale(0.5);
		background-color: $white;
		margin: 0em 0em 64px 0em;
		max-width: 80vw;
		flex-grow: 1;
		align-self: stretch;

		position: absolute;
		top: 10vh;
		margin-left: 10vw;
		border-radius: $border-radius-1;
		padding: 1em 2em;

		@media (max-width: 767px) {
			max-width: 95vw;
			margin-left: 2.5vw;
				
		}
		@media (min-width: 768px) {
			transform: translate3d(0px, 50%, 77px) scale(0.43);
			font-size: 18px;
			max-width: 60ch;
			margin-left: calc(50% - 30ch);
			bottom: 35vh;
			top: unset;
		}
		
	}
	.background-cover {
		background-image: url(../assets/img/jpg/banner_bg.jpg);
		background-size: cover;
		background-position: center center;
		background-repeat: no-repeat;
	}
	@media screen and (max-width: 767px) {
		.banner {
			>.static-logo {
				animation: anime 2s infinite;

				@mixin start {
					transform: scale(1);
				}
				@mixin middle {
					transform: scale(1.05);
				}
				@mixin finish {
					transform: scale(1);
				}
				@keyframes anime {
					0% {
						@include start();
					}
					85% {
						@include middle();
					}
					100% {
						@include finish();
					}
				}
			}
		}
	}
</style>
